import { Model } from '../parents/model';

export class EcoChallengeModel extends Model {
  static ATTR_BANK_ACCOUNT_IBAN = 'bank_account_iban';
  static ATTR_BANK_ACCOUNT_NUMBER = 'bank_account_number';
  static ATTR_BANK_CODE = 'bank_code';
  static ATTR_BANK_SWIFT_CODE = 'bank_swift_code';
  static ATTR_BIRTH_AT = 'birth_at';
  static ATTR_BRING_TO = 'bring_to';
  static ATTR_CREATED_AT = 'created_at';
  static ATTR_CURRENCY_ID = 'currency_id';
  static ATTR_CUSTOMER_ID = 'customer_id';
  static ATTR_DIAL_CODE = 'dial_code';
  static ATTR_EMAIL = 'email';
  static ATTR_EXTERNAL_ID = 'external_id';
  static ATTR_EXTERNAL_ID_TYPE = 'external_id_type';
  static ATTR_FIRST_NAME = 'first_name';
  static ATTR_ID = 'id';
  static ATTR_LAST_NAME = 'last_name';
  static ATTR_NOTE = 'note';
  static ATTR_PAYOFF_METHOD = 'payoff_method';
  static ATTR_PHONE = 'phone';
  static ATTR_STATUS = 'status';
  static ATTR_TYPE = 'type';
  static ATTR_UPDATED_AT = 'updated_at';
  static ATTR_USER_ID = 'user_id';

  static EMBED_PAYLOAD = 'payload';
  static EMBED_STATUS = 'status';
  static EMBED_ADDRESS = 'address';
  static EMBED_BILLING_ADDRESS = 'billing_address';
  static EMBED_ECO_CREDITS = 'eco_credits';
  static EMBED_ECO_CREDITS_DETAIL = 'eco_credits_detail';
  static EMBED_INCORRECTLY_MARKED = 'incorrectly_marked';
  static EMBED_INVOICE = 'invoice';
  static EMBED_USER_EMAIL = 'user_email';
  static EMBED_IS_FIRST_ECO_CHALLENGE = 'is_first_eco_challenge';


  get bankAccountIban() {
    return this.attributes[EcoChallengeModel.ATTR_BANK_ACCOUNT_IBAN];
  }
  get bankAccountNumber() {
    return this.attributes[EcoChallengeModel.ATTR_BANK_ACCOUNT_NUMBER];
  }
  get bankCode() {
    return this.attributes[EcoChallengeModel.ATTR_BANK_CODE];
  }
  get bankSwiftCode() {
    return this.attributes[EcoChallengeModel.ATTR_BANK_SWIFT_CODE];
  }
  get birthAt() {
    return this.attributes[EcoChallengeModel.ATTR_BIRTH_AT];
  }
  get bringTo() {
    return this.attributes[EcoChallengeModel.ATTR_BRING_TO];
  }
  get createdAt() {
    return this.attributes[EcoChallengeModel.ATTR_CREATED_AT];
  }
  get currencyId() {
    return this.attributes[EcoChallengeModel.ATTR_CURRENCY_ID];
  }
  get customerId() {
    return this.attributes[EcoChallengeModel.ATTR_CUSTOMER_ID];
  }
  get dialCode() {
    return this.attributes[EcoChallengeModel.ATTR_DIAL_CODE];
  }
  get email() {
    return this.attributes[EcoChallengeModel.ATTR_EMAIL];
  }
  get externalId() {
    return this.attributes[EcoChallengeModel.ATTR_EXTERNAL_ID];
  }
  get externalIdType() {
    return this.attributes[EcoChallengeModel.ATTR_EXTERNAL_ID_TYPE];
  }
  get firstName() {
    return this.attributes[EcoChallengeModel.ATTR_FIRST_NAME];
  }
  get id() {
    return this.attributes[EcoChallengeModel.ATTR_ID];
  }
  get lastName() {
    return this.attributes[EcoChallengeModel.ATTR_LAST_NAME];
  }
  get note() {
    return this.attributes[EcoChallengeModel.ATTR_NOTE];
  }
  get payoffMethod() {
    return this.attributes[EcoChallengeModel.ATTR_PAYOFF_METHOD];
  }
  get phone() {
    return this.attributes[EcoChallengeModel.ATTR_PHONE];
  }
  get status() {
    return this.attributes[EcoChallengeModel.ATTR_STATUS];
  }
  get type() {
    return this.attributes[EcoChallengeModel.ATTR_TYPE];
  }
  get updatedAt() {
    return this.attributes[EcoChallengeModel.ATTR_UPDATED_AT];
  }
  get userId() {
    return this.attributes[EcoChallengeModel.ATTR_USER_ID];
  }

  get payload() {
    return this.embeds[EcoChallengeModel.EMBED_PAYLOAD];
  }
  get address() {
    return this.embeds[EcoChallengeModel.EMBED_ADDRESS];
  }
  get billingAddress() {
    return this.embeds[EcoChallengeModel.EMBED_BILLING_ADDRESS];
  }
  get statusProperties() {
    return this.embeds[EcoChallengeModel.EMBED_STATUS];
  }
  get ecoCredits() {
    return this.embeds[EcoChallengeModel.EMBED_ECO_CREDITS];
  }
  get ecoCreditsDetail() {
    return this.embeds[EcoChallengeModel.EMBED_ECO_CREDITS_DETAIL];
  }
  get incorrectlyMarked() {
    return this.embeds[EcoChallengeModel.EMBED_INCORRECTLY_MARKED];
  }
  get invoice() {
    return this.embeds[EcoChallengeModel.EMBED_INVOICE];
  }
  get userEmail() {
    return this.embeds[EcoChallengeModel.EMBED_USER_EMAIL];
  }
  get isFirstEcoChallenge() {
    return this.embeds[EcoChallengeModel.EMBED_IS_FIRST_ECO_CHALLENGE];
  }
}
